import axios from "axios";
import { store } from "../store";

const axiosRequest = axios.create({
  // baseURL: "http://192.168.1.7:4305/api/v1",
  baseURL: "https://stageapi.puripolymers.com/api/v1",
});

axiosRequest.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.auth.token;
  config.params = config.params || {};
  config.headers["x-auth-token"] = token;
  return config;
});

export default axiosRequest;
